import { signIn, verificationSignIn, getUserinfo, getCompanyList, getRoleList, getMenuRole } from "@/http/api/auth";
import { checkCompany, getTreeAreaPC } from "@/http/api/workbench";
import _ from "lodash";
import sha256 from "js-sha256";
import { ElMessage } from "element-plus";
import { store } from "@/store";
import { ElMessageBox } from "element-plus";
import router from "@/router";

const authModule = {
  namespaced: true,
  state: {
    token: localStorage.getItem("token") || null,
    uuid: localStorage.getItem("uuid") || null,
    refreshToken: localStorage.getItem("refreshToken") || null,
    userData: localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null,
    areaOptions: localStorage.getItem("areaOptions") ? JSON.parse(localStorage.getItem("areaOptions")) : null,
    companyData: localStorage.getItem("companyData") ? JSON.parse(localStorage.getItem("companyData")) : null,
    roleData: localStorage.getItem("roleData") || [],
    checkCompany: JSON.parse(localStorage.getItem("checkCompany")) || [],
    roleMenuData: JSON.parse(localStorage.getItem("roleMenuData")) || [],
    myApplication: JSON.parse(localStorage.getItem("myApplication")) || {},
    cachedPages: JSON.parse(localStorage.getItem("cachedPages")) || [],
    appExpireTimestamp: JSON.parse(localStorage.getItem("appExpireTimestamp")) || {},
    adminAccountAlert: JSON.parse(localStorage.getItem("adminAccountAlert")) || {},
    signInLoading: false
  },
  getters: {
    isAuth: (state) => {
      return !!state.token && !_.isEmpty(state.userData);
    },

    isCompanyAuth: (state) => {
      return state.companyData.find((item) => item.isDefault).isCompanyAuth;
    },

    isAdmin: (state) => {
      try {
        if (_.isEmpty(store.getters["auth/currentCompany"])) {
          throw new Error();
        }
        const { companyId } = store.getters["auth/currentCompany"];
        if (_.isEmpty(companyId) || companyId === "-1") throw new Error();

        return state.companyData.find((item) => item.isDefault).isMain;
      } catch (error) {
        return false;
      }
    },

    currentCompany: (state) => {
      let ownCompany = { companyId: "-1", companyName: "管管安全" };
      return state.companyData.find((item) => item.isDefault && !item.isExamine) || ownCompany;
    },

    currentCompanyQR: (state) => {
      const { companyId, companyName, ...params } = state.companyData.find((item) => item.isDefault);
      return { companyId, companyName };
    },

    sortCompany: (state) => {
      return state.companyData.map((item) => {
        return {
          label: item.companyName,
          value: item.companyId,
          isExamine: item.isExamine,
          isCompanyAuth: item.isCompanyAuth
        };
      });
    },

    isAllowAccess: (state) => (arg) => {
      const ROLE_DATA = state.roleData;
      return ROLE_DATA.includes(arg) ? true : false;
    },

    isMenuAllowAccess: (state) => (arg, organId) => {
      const ROLE_MENU_DATA = state.roleMenuData;
      if (ROLE_MENU_DATA.length === 0) return;
      let res = ROLE_MENU_DATA.filter((item) => {
        return organId == item.organId;
      });
      return res[0] && res[0].menuList.includes(arg) ? true : false;
    },
    ischeckCompany: (state) => {
      const { isAuth } = state.checkCompany;
      return isAuth || null;
    }
  },
  mutations: {
    setMyApplication(state, val) {
      state.myApplication = val;
      localStorage.setItem("myApplication", JSON.stringify(val));
    },
    setSignInLoading(state, val) {
      state.signInLoading = val;
    },
    setToken(state, val) {
      state.token = val;
      localStorage.setItem("token", val);
    },
    setAppExpireTimestamp(state, val) {
      let { now, data } = val;
      state.appExpireTimestamp[now] = data;
      localStorage.setItem("appExpireTimestamp", JSON.stringify(state.appExpireTimestamp));
    },
    setUUID(state, val) {
      state.uuid = val;
      localStorage.setItem("uuid", val);
    },
    addCachedPages(state, val) {
      if (!state.cachedPages.includes(val)) {
        state.cachedPages.push(val);
        localStorage.setItem("cachedPages", JSON.stringify(state.cachedPages));
      }
    },
    removeCachedPages(state, val) {
      if (state.cachedPages.includes(val)) {
        let index = _.indexOf(state.cachedPages, val);
        state.cachedPages.splice(index, 1);
        localStorage.setItem("cachedPages", JSON.stringify(state.cachedPages));
      }
    },
    setRefreshToken(state, val) {
      state.refreshToken = val;
      localStorage.setItem("refreshToken", val);
    },
    setUserData(state, val) {
      state.userData = val;
      localStorage.setItem("userData", JSON.stringify(val));
    },
    setAreaOptions(state, val) {
      state.areaOptions = val;
      localStorage.setItem("areaOptions", JSON.stringify(val));
    },

    setRoleData(state, arr) {
      state.roleData = arr;
      localStorage.setItem("roleData", arr);
    },
    setcheckCompany(state, arr) {
      state.checkCompany = arr;
      localStorage.setItem("checkCompany", JSON.stringify(arr));
    },

    setMenuRole(state, arr) {
      state.roleMenuData = arr;
      localStorage.setItem("roleMenuData", JSON.stringify(arr));
    },

    setCompanyData(state, data) {
      let { companyId, val } = data;
      val = val.map((item, index) => {
        if (index === 0) {
          item.isDefault = true;
        }
        return item;
      });
      state.companyData = val;
      localStorage.setItem("companyData", JSON.stringify(val));
      _.isEmpty(companyId) && localStorage.setItem("currentCompany", val.length > 0 ? (val[0].isExamine ? "-1" : val[0].companyId) : "-1");
    },

    setCurrentCompany(state, val) {
      let arr = _.cloneDeep(state.companyData);
      arr = arr.map((item) => {
        return {
          ...item,
          isDefault: val === item.companyId
        };
      });
      state.companyData = arr;
      localStorage.setItem("companyData", JSON.stringify(arr));
      localStorage.setItem("currentCompany", val);
    },

    clear(state) {
      state.token = null;
      state.refreshToken = null;
      state.areaOptions = null;
      // state.userData = null;
      // state.companyData = null;
      state.myApplication = {};
      store.commit("notify/setUnread", null);
      store.commit("notify/clear");
      localStorage.removeItem("myApplication");
      localStorage.removeItem("isRequestAccess");
      localStorage.removeItem("roleData");
      localStorage.removeItem("checkCompany");
      localStorage.removeItem("roleMenuData");
      localStorage.removeItem("currentCompany");
      localStorage.removeItem("companyData");
      localStorage.removeItem("userData");
      localStorage.removeItem("areaOptions");
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
    },
    setAdminAccountAlert(state, data) {
      state.adminAccountAlert = data;
      localStorage.setItem("adminAccountAlert", JSON.stringify(data));
    },
    adminAccountMessageAlert(state) {
      ElMessageBox.alert("<strong>您的主账号服务已生效</strong>", "", {
        confirmButtonText: "前去分配权限",
        type: "warning",
        showCancelButton: false,
        buttonSize: "large",
        dangerouslyUseHTMLString: true
      })
        .then(() => {
          router.push("/manage/appManagement");
        })
        .catch(() => {});
    }
  },
  actions: {
    async signIn({ dispatch, commit, state }, options) {
      !state.areaOptions && dispatch("getTreeArea");
      try {
        let result = {};
        if (options.IS_CAPTCHA_TYPE) {
          const { password, IS_CAPTCHA_TYPE, ...params } = options;
          result = await verificationSignIn(params);
        } else {
          let { verificationCode, IS_CAPTCHA_TYPE, ...params } = options;
          params.password = sha256(params.password);
          result = await signIn(params);
        }
        if (result.data.access_token === "error") {
          commit("setSignInLoading", false);
          return {
            account: true,
            userIsImprove: result.data.userIsImprove,
            firstLogin: false
          };
        }
        if (result.data.firstLogin) {
          commit("setSignInLoading", false);
          return {
            loginUser: result.data.loginUser,
            account: false,
            userIsImprove: false,
            firstLogin: result.data.firstLogin
          };
        }
        commit("setToken", result.data.access_token);
        commit("setRefreshToken", result.data.refresh_token);
        if (result.data.userIsImprove) {
          commit("setSignInLoading", false);
          return {
            loginUser: result.data.loginUser,
            account: false,
            userIsImprove: true,
            firstLogin: false
          };
        }
        dispatch("getUserInfo");
        dispatch("getCompanyList");
        return {
          account: false,
          userIsImprove: result.data.userIsImprove,
          userAccountId: result.data.userAccountId
        };
      } catch (error) {
        // ElMessage.error(error.message);
        console.log(error);
        throw error;
      }
    },
    async refSignIn({ dispatch, commit }, options = {}) {
      try {
        options.access_token && commit("setToken", options.access_token);
        options.refresh_toke && commit("setRefreshToken", options.refresh_token);
        dispatch("getUserInfo");
        dispatch("getCompanyList");
      } catch (error) {
        // ElMessage.error(error.message);
        console.log(error);
      }
    },
    async getTreeArea({ state, dispatch, commit }) {
      let { data } = await getTreeAreaPC();
      commit("setAreaOptions", data);
    },
    async getUserInfo({ state, dispatch, commit }) {
      try {
        const { data } = await getUserinfo();
        data.isSuperMan && ElMessage.warning("使用万能密码登录，为避免影响客户侧消息状态，消息模块已隐藏。");
        commit("setUserData", data);

        store.dispatch("notify/openDataset");
        store.dispatch("notify/subscribe", store.state.auth.userData);
        return true;
      } catch (error) {
        _.isEmpty(state.userData) && commit("clear");
        commit("setSignInLoading", false);
        console.log(error);
      }
    },

    async getUserInfoNoMessage({ dispatch, commit }) {
      try {
        const { data } = await getUserinfo();
        commit("setUserData", data);
        return true;
      } catch (error) {
        console.log(error);
      }
    },

    async getCompanyList({ dispatch, commit, state }, companyId) {
      try {
        const result = await getCompanyList();
        commit("setCompanyData", { companyId, val: result.data || [] });
        dispatch("getRoleList");
        dispatch("getMenuRole");
        dispatch("acquirekCompany");
        return result;
      } catch (error) {
        _.isEmpty(state.userData) && commit("clear");
        commit("setSignInLoading", false);
        console.log(error);
      }
    },

    async refreshCompanyInfo({ state, dispatch, commit }) {
      try {
        const { companyId } = store.getters["auth/currentCompany"];
        const result = await getCompanyList();
        commit("setCompanyData", { companyId, val: result.data || [] });
        commit("setCurrentCompany", companyId);
        dispatch("getRoleList");
        dispatch("getMenuRole");
        dispatch("acquirekCompany");
        // router.push("/homePage");
        return result;
      } catch (error) {
        console.log(error);
      }
    },

    async getRoleList({ dispatch, commit, state }) {
      try {
        const result = await getRoleList();
        const AUTH = ["A006", "A007", "A008", "A009"];
        _.intersection(result.data, AUTH).length > 0 ? result.data.push("MEMBER_ALL") : null;
        commit("setRoleData", result.data);
      } catch (error) {
        console.log(error);
      }
    },
    async acquirekCompany({ dispatch, commit, state }) {
      try {
        const { data } = await checkCompany();
        commit("setcheckCompany", data);
      } catch (error) {
        console.log(error);
      }
    },

    async getMenuRole({ dispatch, commit, state }) {
      try {
        const result = await getMenuRole();
        commit("setMenuRole", result.data);
      } catch (error) {
        console.log(error);
      }
    }
  }
};

export default authModule;
